import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Importation from './views/Importation.vue';
import SeaFreight from './views/SeaFreight.vue';
import Document from './views/Document.vue';
import Detail from './views/Detail.vue';
import Contact from './views/contact.vue';
import Tracking from './views/tracking.vue';

Vue.use(Router);

// The forms and the member system are maintained on their own sites; these
// paths forward there. beforeEnter never calls next(), so the browser
// navigates away before the route resolves (no page flash).
const forwardToForms = () => {
  window.location.replace('https://sea.line-1.com/forms/');
};
const forwardToApp = () => {
  window.location.replace('https://air.line-1.com/app/');
};

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/Importation',
      name: 'Importation',
      component: Importation
    },
    {
      path: '/sea-freight',
      name: 'seafreight',
      component: SeaFreight
    },
    {
      path: '/document',
      name: 'document',
      component: Document
    },
    {
      path: '/detail',
      name: 'detail',
      component: Detail
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/login',
      name: 'login',
      beforeEnter: forwardToApp
    },
    {
      path: '/tracking',
      name: 'tracking',
      component: Tracking
    },
    {
      path: '/signup',
      name: 'signup',
      beforeEnter: forwardToApp
    },
    {
      path: '/declaration-forms',
      name: 'declarationforms',
      beforeEnter: forwardToForms
    },
    {
      path: '/declaration-forms/loa',
      name: 'loa',
      beforeEnter: forwardToForms
    },
    {
      path: '/declaration-forms/packing-declaration',
      name: 'packingdeclaration',
      beforeEnter: forwardToForms
    },
    {
      path: '/declaration-forms/coolant-declaration',
      name: 'coolantdeclaration',
      beforeEnter: forwardToForms
    },
    {
      path: '/declaration-forms/shipping-do',
      name: 'shippingdo',
      beforeEnter: forwardToForms
    }
  ],
  mode: 'history'
});
